import { render, staticRenderFns } from "./PlumberManagement.vue?vue&type=template&id=2bbb5b4e"
import script from "./PlumberManagement.vue?vue&type=script&lang=js"
export * from "./PlumberManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports